import svMessages from './messages-sv';

angular
  .module('blocks.i18n')
  .service('messagesSvService', messagesSvService);

function messagesSvService() {
  this.messages = svMessages;
}
